export default "__VITE_ASSET__ddAPEonG__"